import { render } from "./MemorialNames.vue?vue&type=template&id=07c14890&scoped=true"
import script from "./MemorialNames.vue?vue&type=script&lang=js"
export * from "./MemorialNames.vue?vue&type=script&lang=js"

import "./MemorialNames.vue?vue&type=style&index=0&id=07c14890&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c14890"]])

export default __exports__